import { useState, useRef } from "react";
import Config from "../../Config";

import AppContext from "../../AppContext";
import InputText from "../../helpers/InputText";
import InputCombo from "../../helpers/InputCombo";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import MenuTable from "../../helpers/MenuTable";
import men_book from "../../men_book.png"
import BookNew from "./BookNew";
import GroupKids from "../kids/GroupKids";
import BooksEdit from "./BooksEdit";
import Print from "./Print";
import InputComboGrupa from "../../helpers/InputComboGrupa";


function Books(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({  
        nazwa: props.mainView.readFilter('nazwa',''), 
        status: props.mainView.readFilter('status','aktywny'), 
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'), 
        typ: 'grupa',
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);

  const [showPrint, setShowPrint] = useState(-1);
        
    
        const tabRef = useRef(0); //do druku
    
    
        const [view, setView] = useState ( {
            v:'list',
            id: -1
        } );
    
        const [legend, setLegend] = useState([
            {
                cls:'color_deleted',
                title: 'Archiwalny'
            },
        ]);
    



const getTab = () => {
       
 
    props.mainView.setProgress(-2);

   

    fetch( Config.url + '/rest_v1_men,books', {
        method: 'POST', 
        body: JSON.stringify(filterParam), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setTab(res.result);             

                    if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}



        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
            
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
                {
                        var defTimeOut = 1000;
                        if(msg == 'combo') defTimeOut = 10;
                        clearTimeout(AppContext.timeoutId);
                        AppContext.timeoutId = setTimeout( () => {
                            setTab(null); 
                        } , defTimeOut );
                }

            props.mainView.writeFilter(filedName, val);
        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }


        const filterView = () => {
            setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
        }  
        
        
        const filterClear = () => {
 
            props.mainView.writeFilter('nazwa', '');
            props.mainView.writeFilter('status', 'aktywny');            
            props.mainView.writeFilter('p_grupa_id', '_x_');            
        

            setFilterParam({
            
                nazwa: '',                 
                status: 'aktywny',   
                p_grupa_id: '_x_'              ,
                typ: 'grupa',                 

                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },


                limit: 50,
                page: 1,
                show: true, 
            });
            setTab(null);
        }


 const filterApprove = () => {   
     setTab(null)     
 }

 const onChangePagger = (x_limit, x_page) => {

     setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
     setTab(null);
 }


 
 const onChangeSortBy = (sortBy) => {

    setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
    setTab(null);
}



 const changeView = (e ) => {
    var v = e.target.getAttribute('v');
    var id = e.target.getAttribute('id');

    setView({...view, ["v"]:v, ["id"]:id });
}


const onBack = () => {
       
    setView({...view, ["v"]:"list", ["id"]:-1 }); 
   
}

const onSuccess = () => {
       
    setView({...view, ["v"]:"list", ["id"]:-1 }); 
    getTab();
}


    const goPrint = (e) => {

       
        var id = e.target.getAttribute('id');

          setShowPrint(id);
    }

    const closePrint = () => {
        setShowPrint(-1);
    }




 
    if(tab == null)
    {
        setTab([]);
        getTab();
     

        return <div>
            ...
        </div>
    }



         const itemsStatus = [
            { v: '_x_', title: '- - -' },
            { v: 'nieaktywny', title: 'Archiwalny' },        
            { v: 'aktywny', title: 'Aktywne' },         
        ]; 
    

        var sortList = [ 
            {column: "created_at", name: "Data dodania"       }, 
            {column: "updated_at", name: "Data aktualizacji"  }, 
        ]
    




    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
        setView( {
            v:'list',
            id: -1
        });
    }




    if(view.v == 'new')
    {
        return <BookNew  userData={props.userData} mainView={props.mainView} onBack={onBack} onSuccess={onSuccess} typ="grupa" />
    }
    

    
    if(view.v == 'edit')
    {
        return <BooksEdit  userData={props.userData} mainView={props.mainView} onBack={onBack} onSuccess={onSuccess} id={view.id}  />
    }

            var printView = null;
            if(showPrint > 0 ) printView = <Print userData={props.userData} mainView={props.mainView} id={showPrint} typ="pdf" onClose={closePrint} />


 return (

        <div className="view_content">
           
            {printView}


                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                
                {
                    filterParam.show == true  &&
                    <div className="table_filter">

                            <div className="filter_controll">   
                                <label>Nazwa: </label>                             
                                <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />
                            </div> 

                              <div className="filter_controll">   
                                <label>Grupa: </label>                             
                                <InputComboGrupa  mainView={props.mainView}  userData={props.userData} value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Nazwa: "}   />
                            </div> 
 

                            <div className="filter_controll">   
                            <label>Status: </label>                             
                            <InputCombo  items={itemsStatus}  userData={props.userData}  mainView={props.mainView}  value={filterParam.status}   valChange={valChangeListener} goNext={goNextNew} name="status" placeholder={" "}   />
                        </div> 


                            <div className="filter_btn">
                                <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                        </div>
                    </div>
                } 


               

                <div className="bg_center">

                            <div className="table_widget">        

                                    {
                                            props.userData.type  == 'DYREKTOR' &&
                                            <div className="btn" onClick={changeView} v="new" id="-1"  > utwórz nowy dziennik</div>
                                    }
                                 
                                 
                                    <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                        
                                    <InputLegend items={legend}/>

                                    <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                            </div>


                        <div className="scorll_x">
                            <table className="table" ref={tabRef}>


                                        <thead>
                                                <tr className="header">                                                    
                                                    <td className="td_left">LP</td>                                                                                                                                           
                                                    <td className=""> </td>                                                                                                                                           
                                                    <td>Nazwa własna dziennika</td>                                              
                                                    <td >Grupa</td>    
                                                    <td className="td_right">Rok szkolny</td>                                                                                                                                                                                                                                     
                                                    <td className="td_option"> </td>                                              
                                                </tr>
                                        </thead>
                                        <tbody>

                                                {
                                                        tab.map(  (row, inx) => {

                                                              
                                                                    var css = "";    
                                                                    if(row.status == "nieaktywny") css = " color_deleted ";

                                                                    var rowStyle = " row ";
                                                                    if(inx % 2 == 0 )rowStyle = " row2 ";


                                                                return <tr className={ rowStyle +" " + css } key={inx}>
  
                                                                        <td className="gocenter" >{inx+1}</td>                                                                                                                                           
                                                                        <td className="gocenter" > <img src={men_book}  className="ico_directory"  onClick={changeView} v="edit" id={row.id} /></td>                                                                                                                                           
                                                                        <td className="gocenter"  onClick={changeView} v="edit" id={row.id}>{row.nazwa_wlasna}</td>                                             
                                                                        <td className="gocenter">
                                                                            {
                                                                                row.powiazania.map( (prz,ix) => {
                                                                                    return <div>
                                                                                        {prz.nazwa}
                                                                                        {
                                                                                            prz.dzieci != null &&
                                                                                            <GroupKids tab={prz.dzieci} />
                                                                                        }                                                                                            
                                                                                         &nbsp;
                                                                                    </div>
                                                                                } )
                                                                            }
                                                                        </td>     
                                                                        <td className="gocenter">{row.rok_szkolny}</td>                                                                                                                                                                                                                                                                             
                                                                                                          
                                      
                                                                        <MenuTable>
                                                                        <ul>
                                                                       
                                                                            <li  onClick={changeView} v="edit" id={row.id}  >pokaż</li>
                                                                            <li  onClick={goPrint} v="print" id={row.id}  >drukuj .pdf</li>
                                                                         
                                                                        </ul>                                                               
                                                                       </MenuTable> 


                                                                </tr>

                                                        } )

                                                }

                                        </tbody>

                            </table>
                        </div>

                </div>


                <br/>
                <br/>
                <br/>

               


                <div>
                      <h3 className="calColor">ROZPORZĄDZENIE MINISTRA EDUKACJI NARODOWEJ</h3>
                      <p>ogłoszono dnia 15 stycznia 2024 r. obowiązuje od dnia 1 września 2017 r.</p>

                      <p>
                         <p>
                            Prowadzenie dokumentacji przebiegu nauczania, w tym dziennika zajęć, jest jednym z podstawowych obowiązków każdej placówki oświatowej, w tym przedszkola. Obowiązek ten wynika wprost z przepisów prawa oświatowego. W niniejszym artykule omówimy podstawy prawne dotyczące prowadzenia dziennika zajęć przedszkolnych, odwołując się do rozporządzeń: Dz. U. z 2017 r. poz. 1646 oraz Dz. U. z 2019 r. poz. 1664.
                        </p>
                      </p>

                      <p>
                        § 21. 1. Dzienniki, o których mowa w § 2, § 8-13, § 18 i § 20, mogą być prowadzone także w postaci elektronicznej; dzienniki prowadzone w postaci elektronicznej są zwane dalej „dziennikami elektronicznymi”.
                      </p>
                      <p>
                        3. Prowadzenie dziennika elektronicznego wymaga:
                        <ul>
                            <li>1) (uchylony);</li>
                            <li>2) zabezpieczenia danych stanowiących dziennik elektroniczny przed dostępem osób nieuprawnionych;</li>
                            <li>3) zabezpieczenia danych stanowiących dziennik elektroniczny przed zniszczeniem, uszkodzeniem lub utratą;</li>
                            <li>4) rejestrowania historii zmian i ich autorów;</li>
                            <li>5) umożliwienia bezpłatnego wglądu rodzicom do dziennika elektronicznego, w zakresie dotyczącym ich dzieci.</li>
                        </ul>
                      </p>
                </div>

        </div>
    )



}

export default Books;